import { Card } from "antd";
import Button from "./button";
import { colors } from "../../share/constants/enums";
import { useNavigate } from "react-router-dom";

const PendingAdsComp = ({ data, isHomePage, openModal, loader }) => {
  const navigate = useNavigate();
  const setAds = () => {
    navigate("/main/ads/checkout", {
      state: {
        adsData: data,
      },
    });
  };
  return (
    <>
      <Card className="shadow-md ">
        {data?.isApproved === "APPROVED" && !data?.paymentId ? (
          <div className="grid grid-cols-3 my-1 md:grid-cols-3 lg:grid-cols-6 ml-2 justify-between ">
            <div className="">
              <p className="text-primaryPurple font-bold text-lg">Ads Type</p>
              <p className="truncate">{`${data?.advertisementTypeId?.name}`}</p>
            </div>
            <div>
              <p className="text-primaryPurple font-bold text-lg">Days Left</p>
              <p>{`${data?.numberOfDays}`}</p>
            </div>
            <div>
              <p className="text-primaryPurple font-bold text-lg">State</p>
              <p>{`${data?.state}`}</p>
            </div>
            <div>
              <p className="text-primaryPurple font-bold text-lg">Price</p>
              <p>{`$${data?.numberOfDays * 10}`}</p>
            </div>
            <div className="flex">
              {data?.isApproved === "APPROVED" && !data?.paymentId ? (
                <>
                  <div className="flex">
                    <div>
                      <p className="text-primaryPurple font-bold text-lg">
                        Status
                      </p>
                      <p className="text-sm">{`${data?.isApproved}`}</p>{" "}
                    </div>
                  </div>
                  <Button
                    title={"Pay now"}
                    color={colors.primaryPurple}
                    loading={loader}
                    onClick={setAds}
                    className="w-10 mx-2 mt-3"
                  />
                </>
              ) : (
                <>
                  <div className="mr-4">
                    <p className="text-primaryPurple font-bold text-lg">
                      Status
                    </p>
                    <p
                      className="text-sm"
                      style={{ color: data?.paymentId ? "green" : "red" }}
                    >
                      {`${data?.isApproved}`}
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-3 my-1 md:grid-cols-3 lg:grid-cols-5 ml-2 justify-between  ">
            <div className="">
              <p className="text-primaryPurple font-bold text-lg">Ads Type</p>
              <p className="truncate">{`${data?.advertisementTypeId?.name}`}</p>
            </div>
            <div>
              <p className="text-primaryPurple font-bold text-lg">Days Left</p>
              <p>{`${data?.numberOfDays}`}</p>
            </div>
            <div>
              <p className="text-primaryPurple font-bold text-lg">State</p>
              <p>{`${data?.state}`}</p>
            </div>
            <div>
              <p className="text-primaryPurple font-bold text-lg">Price</p>
              <p>${parseFloat(data?.numberOfDays * 10).toLocaleString()}</p>
            </div>
            <div>
              {data?.isApproved === "APPROVED" && !data?.paymentId ? (
                <>
                  <div className="flex">
                    <div>
                      <p className="text-primaryPurple font-bold text-lg">
                        Status
                      </p>
                      <p className="text-sm">{`${data?.isApproved}`}</p>{" "}
                    </div>
                    <div className="flex items-center mr-1">
                      <Button
                        title={"Pay Now"}
                        color={colors.primaryPurple}
                        onClick={setAds}
                        className="w-10 mx-2"
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="mr-4">
                    <p className="text-primaryPurple font-bold text-lg">
                      Status
                    </p>
                    <p
                      className="text-sm"
                      style={{ color: data?.paymentId ? "green" : "red" }}
                    >
                      {`${data?.isApproved}`}
                    </p>
                  </div>
                </>
              )}
            </div>
            <div></div>
          </div>
        )}
      </Card>
    </>
  );
};
export default PendingAdsComp;
